import { useMutation } from "@tanstack/react-query";
import { supabase } from "index";
import { apiRequest } from "utils/api";

export const useAuthenticationActions = () => {
  const signInMutation = useMutation({
    mutationFn: async ({ email, password }: { email: string; password: string }) => {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
    },
  });

  const signOutMutation = useMutation({
    mutationFn: async () => {
      await supabase.auth.signOut();
    },
  });

  const resetPasswordMutation = useMutation({
    mutationFn: async ({ email, redirectTo }: { email: string; redirectTo: string }) => {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo,
      });
      if (error) throw error;
    },
  });

  const updatePasswordMutation = useMutation({
    mutationFn: async (password: string) => {
      const { error } = await supabase.auth.updateUser({
        password,
      });
      if (error) throw error;
    },
  });

  const signUpMutation = useMutation({
    mutationFn: async ({
      email,
      lender_company,
      companyName,
      first_name,
      last_name,
    }: {
      email: string;
      lender_company: string;
      companyName: string;
      first_name: string;
      last_name: string;
    }) => {
      await apiRequest("/supabase/borrowers/register", {
        email,
        lender_company,
        companyName,
        first_name,
        last_name,
      });
    },
  });

  return {
    signIn: signInMutation,
    signOut: signOutMutation,
    resetPassword: resetPasswordMutation,
    updatePassword: updatePasswordMutation,
    signUp: signUpMutation,
  };
};
